import { useState } from "react";
import "./App.css";
import Home from "./pages/Home";
import Footer from "./componenets/Footer";
import Header from "./componenets/Header";
import { productsData } from "./api/Api";
import Product from "./componenets/Product";
import Login from "./pages/Login";
import{
  createBrowserRouter,
  Outlet,
  RouterProvider,
  ScrollRestoration,
}
from "react-router-dom";
import Carts from "./pages/Carts";


const Layout=()=>{
  return(
    <div>
      <Header ></Header>
      <ScrollRestoration></ScrollRestoration>
      <Outlet></Outlet>
      <Footer></Footer>
    </div>
  );
};

const router=createBrowserRouter([
  {
    path:"/",
    element:<Layout></Layout>,
    children:[
      {
        path:"/",
        element:<Home></Home>,
       loader:productsData
      },
      {
        path:"/product/:id",
        element:<Product/>
      }
      ,
      {
       path:"/cart",
       element:<Carts></Carts>
      },
      {
        path:"/login",
        element:<Login></Login>
      }
    ]
  
  }
])

function App() {
  
  return (
   <div className="font-bodyFont">
  
<RouterProvider router={router}></RouterProvider>
</div>
  );
}

export default App;
